import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";

class Information_component_overview extends PureComponent {
  render() {
    return (
      <div className="row" id="information_component_overview">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Information Component Overview</h2>
              <p>
                Information components are simple components that allow you to
                display headings or paragraph text in any layout. Information
                components support the hide_if_eval giving you dynamic control
                on when and under what conditions the user will see the
                components. This makes them suitable for warning or "more
                detail" messages in complex workflows.
              </p>
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="hidden-sm-xs col-md-6 darkCol">
          <div className="contentDark"></div>
        </div>
      </div>
    );
  }
}

export default Information_component_overview;



// WEBPACK FOOTER //
// ./src/components/knowlege/interface/Information_component_overview.js